import React from "react";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import validator from "validator";

// Custom components
import colors from "../../constants/Colors";
import { LoadingButton, StyledTextField } from "../general";

const Form = ({
  userValidateEmail,
  requestCode,
  type = "LOG_IN",
  openSignUp = () => {},
  openLogin = () => {},
  emailLoading,
  editErrors,
  formErrors,
  editFormData,
  formData,
  t,
}) => {
  const validateEmail = () => {
    console.log(formData["email"]);

    if (!formData["email"]) {
      editErrors({ email: t("auth.noEmailError") });
      return true;
    } else if (validator.isEmpty(formData["email"])) {
      editErrors({ email: t("auth.noEmailError") });
      return true;
    } else if (!validator.isEmail(formData["email"])) {
      editErrors({ email: t("auth.invalidEmail") });
      return true;
    }
    editErrors({ email: "" });
    return false;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let failed = validateEmail();
    if (failed === false) {
      console.log("validate email");
      console.log(type);
      if (type === "LOG_IN") {
        requestCode();
      } else {
        userValidateEmail();
      }
    }
  };

  let emailErrorMsg = formErrors ? formErrors["email"] : "";

  return (
    <Grid container alignItems="center" style={{ height: "100%" }}>
      <Grid item style={{ flex: 1 }}>
        <form style={{ width: "100%" }} onSubmit={handleSubmit}>
          <div style={{ padding: 10, marginBottom: 30 }}>
            <StyledTextField
              name={"email"}
              value={formData ? formData["email"] : ""}
              onChange={(e) => {
                editFormData("email", e.target.value);
              }}
              label={t("auth.email")}
              error={emailErrorMsg && emailErrorMsg !== ""}
              errorText={emailErrorMsg}
            />
            <LoadingButton
              text={t("general.nextStep")}
              loading={emailLoading}
            />
            <BottomText
              type={type}
              openSignUp={openSignUp}
              openLogin={openLogin}
              t={t}
            />
          </div>
        </form>
      </Grid>
    </Grid>
  );
};

const BottomText = ({ type, openSignUp, openLogin, t }) => {
  if (type === "LOG_IN") {
    return (
      <p style={{ fontSize: 12, fontWeight: 500, color: colors.grey }}>
        {t("auth.newToCLMTE")}{" "}
        <span
          onClick={openSignUp}
          style={{
            color: colors.mainGreen,
            fontWeight: 600,
            marginTop: 16,
            cursor: "pointer",
          }}
        >
          {t("auth.createAccount")}
        </span>
      </p>
    );
  } else if (type === "SIGN_IN") {
    return (
      <p style={{ fontSize: 12, fontWeight: 500, color: colors.grey }}>
        {t("auth.alreadyHaveAccount")}{" "}
        <span
          onClick={openLogin}
          style={{
            color: colors.mainGreen,
            fontWeight: 600,
            marginTop: 16,
            cursor: "pointer",
          }}
        >
          {t("auth.logIn")}.
        </span>
      </p>
    );
  }
};

export default withTranslation("common")(Form);
